











import { Condition } from '@ajax/vue/components/templates/item-list/condition/contactlens/model/condition'
import { Component, Prop, Vue } from 'vue-property-decorator'
import BaseButtonVue from './BaseButtonVue.vue'

@Component({
  components: {
    BaseButtonVue,
  },
})
export default class ColorButtonView extends Vue {
  @Prop({ required: true })
  readonly condition: Condition

  get colorIconClass(): string {
    const colorName = this.condition.value.split('.').reverse()[0]

    return `contact-lens-color-icon--${colorName}`
  }

  onClick(condition: Condition) {
    this.$emit('click', condition)
  }
}
